import $ from "jquery";

function changePage(href) {
    if ( 'localStorage' in window ) {
        window.localStorage.setItem('scroll-to', '#products-filter');
    }

    window.location.href = href;
}

$( document ).ready( function() {
    const $productListPagination = $('#products-pagination');

    $productListPagination.find('.mdl_pagination_list__inner').on('click', '.prev, .next', function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        changePage(href);
    });
});

export default changePage;
